import axios from "../shared/axios";
import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";

export function getRegisterList(contractid) {
    return axios.get(`/api/ActivitySchedule/RegisterList`, { params: { contractid } });
}


export function getToSelectList(contractid, taskorderid, projectorderid) {
    taskorderid = taskorderid || 0;
    projectorderid = projectorderid || 0;
    return axios.get(`/api/ActivitySchedule/ToSelectList`, { params: { contractid, taskorderid: taskorderid, projectorderid: projectorderid } });
}


export function fetchSecondaryDateChanges(activityscheduleid) {
    return axios.get(`/api/SecondaryActivity/LoadChanges`, { params: { activityscheduleid } });
}


export function regenerateContractDateChanges(contractid) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.patch(`/api/ActivitySchedule/RegenerateContractDateChanges`, null, { params: { contractid } });
            // store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function updateContractOtherDate(data) {
  return new Promise((resolve, reject) => {
    axios.put(`/api/ActivitySchedule/Update`, data)
      .then(result => {
        store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_CONTRACT });
        resolve(result);
      })
      .catch(error => reject(error));
  });
}